import dayjs from 'dayjs';
import { Contact, ContactInfoFormData } from '../types';
import { ContactMetadataFormData } from '../types/ContactMetadataFormData';
import { ContactInfoRequestFormData } from '../types/ContactInfoRequestFormData';

export function buildContactInfoFormData(data: Contact): ContactInfoFormData {
  return {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: +data.phoneNumber.replace('+1', ''),
    email: data.email,
    timeZone: data.timeZone,
    birthdate: data.birthdate,
    assignedTo: data.assignedTo,
    validStatus: data.validStatus,
  };
}

export function buildContactInfoRequestFormData(
  data: ContactInfoFormData,
): ContactInfoRequestFormData {
  return {
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber.toString(),
    email: data.email,
    timeZone: data.timeZone,
    assignedTo: data.assignedTo,
    birthdate: dayjs(data.birthdate).isValid() ? dayjs(data.birthdate).format('YYYY-MM-DD') : "",
    validStatus: data.validStatus,
  };
}

export function buildContactCustomFieldsFormData(data: Contact): ContactMetadataFormData {
  return {
    contactId: data.id,
    customFields: data.metadata,
  };
}
